// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"591":"cb3f392d","634":"1aaf7edb","787":"af59b646"}[chunkId] + ".chunk.js";
};